import { useMutation } from '@tanstack/react-query';
import { SecService } from '../service/SecService';
import type { SecModel, SecQueryInput } from '../service/SecService';

const useSecQueryMutation = () =>
  useMutation({
    mutationFn: (input: SecQueryInput) => SecService.dispatch(input),
  });

export type { SecModel, SecQueryInput };
export { useSecQueryMutation };
